import PortOpeningObjectOnPrem from "../../entities/OnPremPortOpeningObject";

export default class SubmitPortOpeningObjectOnPrem {

	operation!: string;

	objectIPs!: string;

    objectURLsFQDNs!: string;

	nestedObjects!: string;

	description!: string;

	name: string;

	constructor(rule: PortOpeningObjectOnPrem) {
		Object.assign(this, rule);
		this.operation = rule.operation?.name;
		this.name = rule.name;
	}
}